import React from "react";
import Seo from "../components/Seo";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { Reveal } from "../lib/motion";
import { useLang } from "../i18n/LanguageContext";
import { IMAGES, INDUSTRIES } from "../data";

export default function Industries() {
  const { t } = useLang();
  return (
    <div data-testid="industries-page" className="bg-ink-950">
      <Seo title="Who We Serve" path="/industries" description="North Peak serves homes, offices, medical facilities, retail, industrial, property managers, Airbnb and post-construction across Montreal and the Greater Montreal Area." keywords="Cleaning Services Montreal, Residential Cleaning Montreal, Commercial Cleaning Montreal" />
      <PageHero
        overline={t("Industries We Serve")}
        title={t("Specialized programs for every commercial environment.")}
        subtitle={t("From medical clinics to industrial plants, we tailor standards, staffing, and compliance to your sector.")}
        image={IMAGES.office}
      />

      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.title} delay={(i % 3) * 0.1}>
              <div data-testid={`industry-page-card-${i}`} className="group relative aspect-[4/5] overflow-hidden rounded-3xl bg-ink-800 card-hover border border-white/8">
                <img src={ind.img} alt={ind.title} className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-60 group-hover:scale-110 transition-all duration-700 ease-out" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/50 to-transparent" />
                <div className="absolute inset-0 p-8 flex flex-col justify-end">
                  <div className="h-11 w-11 rounded-2xl glass flex items-center justify-center mb-4">
                    <ind.icon className="h-5 w-5 text-steel-light" />
                  </div>
                  <h3 className="font-serif text-2xl text-white mb-2" style={{ fontWeight: 500 }}>{t(ind.title)}</h3>
                  <p className="text-white/60 text-sm leading-relaxed">{t(ind.desc)}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-ink-900 py-20 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <Reveal><h2 className="font-serif text-gradient text-3xl md:text-4xl mb-6" style={{ fontWeight: 500 }}>{t("Your sector not listed? We likely serve it.")}</h2></Reveal>
          <Reveal delay={0.15}>
            <Link to="/contact" className="group inline-flex items-center gap-2 text-white font-600 text-sm">
              {t("Talk to our team")} <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
